export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-400 border border-primary-500/30 mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            商务合作 / 内容投稿
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-8">
            如果您有商务合作意向、片源投稿需求，或在使用过程中遇到任何问题，欢迎通过以下方式联系我们。97影视团队会尽快回复您的消息。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-100 border border-background-200/60 rounded-lg p-5">
              <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-primary-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">广告投放 · 品牌联动</p>
            </div>
            <div className="bg-background-100 border border-background-200/60 rounded-lg p-5">
              <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center mx-auto mb-3">
                <i className="ri-send-plane-line text-accent-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">片源推荐 · 影评投稿</p>
            </div>
            <div className="bg-background-100 border border-background-200/60 rounded-lg p-5">
              <div className="w-10 h-10 rounded-lg bg-secondary-500/15 flex items-center justify-center mx-auto mb-3">
                <i className="ri-question-line text-secondary-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">播放问题 · 功能建议</p>
            </div>
          </div>

          <div className="bg-background-100 border border-background-200/60 rounded-lg p-6">
            <p className="text-sm text-foreground-600 mb-2">
              发送邮件至：
            </p>
            <p className="text-base font-medium text-primary-500">
              contact@97movies.com
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}